<template>
  <div class="rootDiv">
    <div>
      <div>
        <img :src="contry.nationalflag" alt="" :style="{'width':width}">
      </div>
      <div>
        <span style="font-size: 2rem;color: #2986de">{{ contry.name }}</span>
      </div>
    </div>
    <div>
      <Cell v-show="contry.cname" title="中文名称：" style="text-align: left" :value="contry.cname"></Cell>
      <Cell v-show="contry.ename" title="英文名称：" style="text-align: left" :value="contry.ename"></Cell>
      <Cell v-show="contry.continent" title="所属州：" style="text-align: left" :value="contry.continent"></Cell>
      <Cell v-show="contry.capital" title="首都：" style="text-align: left" :value="contry.capital"></Cell>
      <Cell v-show="contry.maincity" title="主要城市：" style="text-align: left" :value="contry.maincity"></Cell>
      <Cell v-show="contry.nationalday" title="国庆日：" style="text-align: left" :value="contry.nationalday"></Cell>
      <Cell v-show="contry.nationalanthem" title="国歌：" style="text-align: left" :value="contry.nationalanthem"></Cell>
      <Cell v-show="contry.code" title="国家代码：" style="text-align: left" :value="contry.code"></Cell>
      <Cell v-show="contry.language" title="官方语言：" style="text-align: left" :value="contry.language"></Cell>
      <Cell v-show="contry.currency" title="货币：" style="text-align: left" :value="contry.currency"></Cell>
      <Cell v-show="contry.timezone" title="时区：" style="text-align: left" :value="contry.timezone"></Cell>
      <Cell v-show="contry.political" title="政治体制：" style="text-align: left" :value="contry.political"></Cell>
      <Cell v-show="contry.leader" title="国家领袖：" style="text-align: left" :value="contry.leader"></Cell>
      <Cell v-show="contry.population" title="人口数量：" style="text-align: left" :value="contry.population"></Cell>
      <Cell v-show="contry.populationdensity" title="人口密度：" style="text-align: left"
            :value="contry.populationdensity"></Cell>
      <Cell v-show="contry.mainethnic" title="主要民族：" style="text-align: left" :value="contry.mainethnic"></Cell>
      <Cell v-show="contry.mainreligion" title="主要宗教：" style="text-align: left" :value="contry.mainreligion"></Cell>
      <Cell v-show="contry.area" title="国土面积：" style="text-align: left" :value="contry.area"></Cell>
      <Cell v-show="contry.waterrate" title="水域率：" style="text-align: left" :value="contry.waterrate"></Cell>
      <Cell v-show="contry.gdp" title="GDP总计：" style="text-align: left" :value="contry.gdp"></Cell>
      <Cell v-show="contry.avggdp" title="人均GDP：" style="text-align: left" :value="contry.avggdp"></Cell>
      <Cell v-show="contry.areacode" title="国际电话区号：" style="text-align: left" :value="contry.areacode"></Cell>
      <Cell v-show="contry.domain" title="国际域名缩写：" style="text-align: left" :value="contry.domain"></Cell>
      <Cell v-show="contry.roadaccess" title="道路通行：" style="text-align: left" :value="contry.roadaccess"></Cell>
      <Cell v-show="contry.mainuniversity" title="主要学府：" style="text-align: left" :value="contry.mainuniversity"></Cell>
      <Cell v-show="contry.humanindex" title="人类发展指数：" style="text-align: left" :value="contry.humanindex"></Cell>
      <Cell v-show="contry.nationalmotto" title="国家格言：" style="text-align: left" :value="contry.nationalmotto"></Cell>
      <Cell v-show="contry.nationalflower" title="国花：" style="text-align: left" :value="contry.nationalflower"></Cell>
      <Cell v-show="contry.largestcity" title="最大城市：" style="text-align: left" :value="contry.largestcity"></Cell>
      <Cell v-show="contry.foreignname" title="外文名称：" style="text-align: left" :value="contry.foreignname"></Cell>
      <Cell v-show="contry.climate" title="气候条件：" style="text-align: left" :value="contry.climate"></Cell>
      <Cell v-show="contry.geoposition" title="地理位置：" style="text-align: left" :value="contry.geoposition"></Cell>
      <Cell v-show="contry.govresidence" title="政府驻地：" style="text-align: left" :value="contry.govresidence"></Cell>
    </div>
  </div>
</template>

<script>
import {Cell} from 'mint-ui';

export default {
  name: "ContryDetails",
  components: {
    Cell
  },
  mounted() {
    if (this.$route.params.contry !== undefined) {
      this.contry = this.$route.params.contry

    } else {
      this.$router.go(-1)
    }
    this.width = (document.body.clientWidth + 20) + "px"
  },
  methods: {},
  data() {
    return {
      contry:
          {
            area: null,
            areacode: null,
            avggdp: null,
            capital: null,
            climate: null,
            cname: null,
            code: null,
            continent: null,
            currency: null,
            domain: null,
            ename: null,
            foreignname: null,
            gdp: null,
            geoposition: null,
            govresidence: null,
            humanindex: null,
            id: null,
            initial: null,
            iscountry: null,
            language: null,
            largestcity: null,
            leader: null,
            maincity: null,
            mainethnic: null,
            mainreligion: null,
            mainuniversity: null,
            name: null,
            nationalanthem: null,
            nationalday: null,
            nationalflag: null,
            nationalflower: null,
            nationalmotto: null,
            political: null,
            population: null,
            populationdensity: null,
            roadaccess: null,
            timezone: null,
            waterrate: null,
          },
      width: null,
    }
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin: -0.5rem;
}

/deep/ .mint-cell-title {
  min-width: 30%;
}
</style>
